module.exports = __webpack_public_path__ + "static/winner_best_intermediary_lender_border-5df9235bcc35743bf7fe44c2470bb111.png";